import { render, staticRenderFns } from "./FilesRecommendations.vue?vue&type=template&id=30ba6341&scoped=true"
import script from "./FilesRecommendations.vue?vue&type=script&lang=js"
export * from "./FilesRecommendations.vue?vue&type=script&lang=js"
import style0 from "./FilesRecommendations.vue?vue&type=style&index=0&id=30ba6341&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba6341",
  null
  
)

export default component.exports